// extracted by mini-css-extract-plugin
export default {"content":"AddToLightboxDialog_content__goryC","cancelButton":"AddToLightboxDialog_cancelButton__26tCy","confirmButton":"AddToLightboxDialog_confirmButton__BD85B"};